export const DO_TENKEN = {
  suru: 1,
  shinai: 2,
  gojitsu: 3
};
// do, do not do, later date
